<div class="col-12 footer-login pt-4">
    <div class="container font-size-14">
        <p class="font-size-14">{{ '© 2022 Eficacia | Efi Ecosystem. Todos los derechos reservados' | translate }}</p>
        <p><a href="#" class="link-black-404040">{{ 'Nuestras políticas' | translate }}</a></p>
        <p><strong>{{ 'Contacto:' | translate }}</strong> {{ '(57) 321 54160  -  ecosystem@eficacia.com.co' | translate }}</p>
    </div>
</div>
